import {
    type FLAT_RATE_PLANS,
    PLAN_CATALOG_VERSION,
    DEFAULT_PLAN_CATALOG_VERSION,
} from "../../flatRateBilling";
import { FlatRatePlan } from "../../schemas/billing.schema";
import { BillingStatus, SubscriptionDetails } from "../../types/billing";
import { valueOrNull } from "../dto-helpers";
import { SubscriptionDetailsDto } from "./subscription-details.dto";

export interface Params {
    totalUsage: number;
    plans: FlatRatePlan[];
    trialAvailable: boolean;
    billingManagedByOrganization: boolean;
    currentPlan: FLAT_RATE_PLANS;
    subscriptionDetails?: SubscriptionDetails;
    planCatalogVersion?: PLAN_CATALOG_VERSION;
    transactionCount?: number;
    enrichmentQuota?: { used: number; limit: number } | null;
}

export class BillingStatusDto {
    static deserialize(data: BillingStatusDto): BillingStatus {
        return {
            ...data,
            subscriptionDetails: valueOrNull(
                data.subscriptionDetails,
                SubscriptionDetailsDto.deserialize,
            ),
            planCatalogVersion:
                data.planCatalogVersion ?? DEFAULT_PLAN_CATALOG_VERSION,
        };
    }

    public subscriptionDetails: SubscriptionDetailsDto | null;
    public totalUsage: number;
    public plans: FlatRatePlan[];
    public trialAvailable: boolean;
    public billingManagedByOrganization: boolean;
    public currentPlan: FLAT_RATE_PLANS;
    public planCatalogVersion: PLAN_CATALOG_VERSION;
    public transactionCount: number;
    public enrichmentQuota: { used: number; limit: number } | null;

    constructor(params: Params) {
        this.totalUsage = params.totalUsage;
        this.plans = params.plans;
        this.trialAvailable = params.trialAvailable;
        this.billingManagedByOrganization = params.billingManagedByOrganization;
        this.subscriptionDetails = params.subscriptionDetails
            ? new SubscriptionDetailsDto(params.subscriptionDetails)
            : null;
        this.currentPlan = params.currentPlan;
        this.planCatalogVersion =
            params.planCatalogVersion ?? DEFAULT_PLAN_CATALOG_VERSION;
        this.transactionCount = params.transactionCount ?? 0;
        this.enrichmentQuota = params.enrichmentQuota ?? null;
    }
}
